import React from 'react';
import { motion } from 'framer-motion';
import './Carrier.css';
import { useNavigate } from 'react-router-dom';
// Asset Imports
import heroMain from '../../assets/Carrier/hero (1).png';
import heroSmall from '../../assets/Carrier/hero (2).png';
import cultureImg from '../../assets/Carrier/hero (3).png';
import tickImg from '../../assets/Carrier/Tick Icon.png'; // Update to your correct check icon filename


// What We Offer Icons
import iconGrowth from '../../assets/Carrier/img (1).png';
import iconExposure from '../../assets/Carrier/img (2).png';
import iconTeam from '../../assets/Carrier/img (3).png';
import iconStability from '../../assets/Carrier/img (4).png';
import iconLearning from '../../assets/Carrier/img (5).png';
import iconCulture from '../../assets/Carrier/img (6).png';
import CustomButton from '../Button/CustomButton';

const Careers = () => {
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
  };
  const navigate = useNavigate();
  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.15 } }
  };

  const openings = [
    { title: "Solar Project Engineer", loc: "India (onsite) - Full Time" },
    { title: "Solar Project Engineer", loc: "India (onsite) - Full Time" },
    { title: "Project Coordinator (EPC)", loc: "India (onsite) - Full Time" },
    { title: "Renewable Energy Analyst", loc: "India (onsite) - Full Time" },
    { title: "Business Development", loc: "India (onsite) - Full Time" },
    { title: "Electrical Engineer", loc: "India (onsite) - Full Time" },
  ];

  return (
    <div className="careers-page">
      {/* SECTION 1: HERO - Staggered Row Alignment */}
      <section className="careers-hero">
        <div className="container mt-5">
          <motion.div className="section-badge" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>JOIN US</motion.div>
          <motion.h1 initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
            Build The Future <span>Of Clean Energy With Us</span>
          </motion.h1>
          <motion.p className="hero-subtext" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
            We work on real renewable energy projects across India. Join us to grow your career while helping build cleaner energy solutions.
          </motion.p>

          <div className="hero-layout-row">
            {/* Left: Main Large Image */}
            <div className="hero-col-main">
              <img src={heroMain} alt="Office" className="hero-img-large" />
            </div>

            {/* Right: Stats and Small Image Column */}
            <div className="hero-col-side">
              <div className="stats-row">
                <div className="stat-card">
                  <h2>6+</h2>
                  <p>Experience in Renewable Energy Projects</p>
                </div>
                <div className="stat-card">
                  <h3>Pan-India Presence</h3>
                  <p>Projects across multiple Indian states</p>
                </div>
              </div>
              <div className="hero-col-bottom-img">
                <img src={heroSmall} alt="Meeting" className="hero-img-small" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2: OUR CULTURE - Heading and Description */}
      <section className="careers-culture">
        <div className="container">
          <div className="culture-flex-layout">
            <motion.div className="culture-text-content" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
              <span className="section-badge-small">OUR CULTURE</span>
              <h2>Why Work With Dazbog</h2>
              <p>We are a renewable energy advisory and execution-focused company. Our teams work closely with developers, investors, and EPCs on real-world projects.</p>

              <div className="culture-points-list">
                <div className="culture-point-item">
                  <img src={tickImg} alt="check" className="point-icon" />
                  <div className="point-text">
                    <strong>Competitive Salaries</strong>
                    <p>Work on real renewable energy projects</p>
                  </div>
                </div>
                <div className="culture-point-item">
                  <img src={tickImg} alt="check" className="point-icon" />
                  <div className="point-text">
                    <strong>Professional Development</strong>
                    <p>Exposure to solar, BESS, hybrid, and green hydrogen</p>
                  </div>
                </div>
                <div className="culture-point-item">
                  <img src={tickImg} alt="check" className="point-icon" />
                  <div className="point-text">
                    <strong>Flexible Work Arrangements</strong>
                    <p>Learn from experienced professionals</p>
                  </div>
                </div>
              </div>
              <CustomButton
                variant="green"
                size="lg"
                text="Get Started Now"
                onClick={() => navigate("/contact")}
              />
            </motion.div>

            <motion.div className="culture-image-box" initial={{ opacity: 0, x: 50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
              <img src={cultureImg} alt="Building" className="culture-main-img" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* SECTION 3: WHAT WE OFFER */}
      <section className="careers-offers">
        <div className="container">
          <motion.div className="section-header-center" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
            <h2>What We Offer</h2>
            <p>Learn through live projects, mentoring, and hands-on exposure.</p>
          </motion.div>
          <motion.div className="offers-grid-layout" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{ once: true }}>
            {[
              { icon: iconGrowth, title: "Professional Growth", desc: "Learn through live projects, mentoring, and hands-on exposure." },
              { icon: iconExposure, title: "Project Exposure", desc: "Work on solar, hybrid, BESS, and emerging energy projects." },
              { icon: iconTeam, title: "Supportive Team", desc: "Collaborate with engineers, advisors, and project teams." },
              { icon: iconStability, title: "Work Stability", desc: "Long-term projects with steady growth opportunities." },
              { icon: iconLearning, title: "Flexible Learning", desc: "On-the-job learning instead of classroom-only training." },
              { icon: iconCulture, title: "Healthy Work Culture", desc: "Clear communication and realistic timelines." },
            ].map((offer, i) => (
              <motion.div key={i} className="offer-feature-card" variants={fadeInUp}>
                <div className="offer-icon-wrapper"><img src={offer.icon} alt={offer.title} /></div>
                <h4>{offer.title}</h4>
                <p>{offer.desc}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* SECTION 4: OPENINGS */}
      <section className="careers-openings">
        <div className="container">
          <div className="section-header-center">
            <span className="section-badge-small-alt">JOIN US</span>
            <h2>Current Openings</h2>
            <p>We are always looking for motivated professionals who want to work in renewable energy.</p>
          </div>
          <div className="openings-grid-list">
            {openings.map((job, i) => (
              <motion.div key={i} className="opening-row-card" initial="hidden" whileInView="visible" variants={fadeInUp} viewport={{ once: true }}>
                <div className="job-details">
                  <h4>{job.title}</h4>
                  <p>{job.loc}</p>
                </div>
                <button
                  className="btn-apply-now"
                  onClick={() => navigate('/careers/solar-engineer')}
                >
                  Apply now
                </button>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 5: FINAL CTA */}
      <section className="careers-cta-section">
        <div className="container">
          <motion.div className="cta-banner-box" initial={{ scale: 0.95, opacity: 0 }} whileInView={{ scale: 1, opacity: 1 }} viewport={{ once: true }}>
            <h2>Interested In Working With Us?</h2>
            <p className='mb-4'>If you are passionate about clean energy and want to grow with real projects, we would love to hear from you.</p>
            <button className="btn-white-cta" onClick={() => navigate("/contact")} >Get Started Now</button>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Careers;